export enum UnfitType {
  Permanent = "permanent",
  Temporary = "temporary",
}
